import '@/css/componentCss/ShortBoxContainer.css';
import {createComponent} from'@/js/utils.js';
import {openVideo} from '@/js/video.js'
import day from 'dayjs';

export const createShortImageBox = function (dataList, node) {
  let nodeList = []
  for (var i = 0; i < dataList.length; i++) {
    nodeList.push({
        tag:"div",classList:["shortImageBox","wow","fadeInUp"],
        children:[
          {tag:'a',classList:["group"],children:[
              {tag:'div',classList:["shotImage"],children:[
                  {tag:"div",classList:["imageContainer"],children:[
                      {tag:'div',classList:["imgBox"],children:[
                          {tag:'img',setting:{src:dataList[i].imageUrl}}
                      ]}
                  ]}
              ]}
          ]},
          {tag:'div',classList:["textContainer"],children:[
              {tag:'div',classList:["title"],text:dataList[i].title},
          ]}
        ]
    })
  }
  createComponent(nodeList,node)
};
export const createShortSwiperItem = function (dataList, node) {
    var shortImagSwiper = document.createElement("div");
    shortImagSwiper.classList.add("swiper-wrapper")
    var nodeList = []
    for(var i =0 ; i<dataList.length;i++){
        nodeList.push({
            tag:'div',classList:["swiper-slide","shortImageBox","wow","fadeInUp"],children:[
                {tag:'a',classList:["group"],setting:{href:"../../NewsContent/index.html?id="+dataList[i].id,target:'_blank'},children:[
                    {tag:'div',classList:["shotImage"],children:[
                        {tag:'div',classList:["imageContainer"],children:[
                            {tag:"div",classList:["imgBox"],children:[
                                {tag:"img",setting:{src:dataList[i].image}}
                            ]}
                        ]}
                    ]},
                    {tag:'div',classList:["textContainer"],children:[
                        {tag:'div',classList:["title"],text:dataList[i].title},
                    ]}
                ]},
            ]
        })
    }
    createComponent(nodeList,shortImagSwiper)
    node.appendChild(shortImagSwiper)
}
export const createProductImageBox = function (dataList, node) {
    let nodeList = []
    for (var i = 0; i < dataList.length; i++) {
      nodeList.push({
          tag:"div",classList:["shortImageBox","wow","fadeInRightBig"],
          children:[
            {tag:'a',classList:["group"],children:[
                {tag:'div',classList:["shotImage","productBox"],children:[
                    {tag:"div",classList:["imageContainer"],children:[
                        {tag:'div',classList:["imgBox"],children:[
                            {tag:'img',setting:{src:dataList[i].imageUrl}}
                        ]}
                    ]}
                ]}
            ]},
            {tag:'div',classList:["msgContainer"],children:[
                {tag:'div',classList:["cn"],text:dataList[i].cnName},
                {tag:'div',classList:["en"],text:dataList[i].enName},
            ]}
          ]
      })
    }
    createComponent(nodeList,node)
  };
  export const  createVideoImageBox = function (dataList, node) {
    let nodeList = []
    for (var i = 0; i < dataList.length; i++) {
      nodeList.push({
          tag:"div",classList:["shortImageBox","wow","fadeInUp"],
          children:[
            {tag:'a',classList:["group"],children:[
                {tag:'div',classList:["shotImage"],children:[
                    {tag:"div",classList:["imageContainer"],children:[
                        {tag:'div',classList:["btn"],setting:{onclick:openVideo(dataList[i].mediaUrl) },children:[
                            {tag:'div',classList:["playIcon"]}
                        ]},
                        {tag:'div',classList:["imgBox"],children:[
                            {tag:'img',setting:{src:dataList[i].image}}
                        ]}
                    ]}
                ]}
            ]},
            {tag:'div',classList:["textContainer"],children:[
                {tag:'h4',classList:["title"],text:dataList[i].title},
                {tag:'div',classList:["boxDate"],text:day(dataList[i].createDate*1000).format("YYYY-MM-DD HH:mm:ss")},
            ]}
          ]
      })
    }
    createComponent(nodeList,node)
  };
  export const createNewsBox = function (dataList, node) {
    let nodeList = []
    for (var i = 0; i < dataList.length; i++) {
      nodeList.push({
          tag:"div",classList:["shortImageBox","wow","fadeInUp"],
          children:[
            {tag:'a',classList:["group"],setting:{href:"../../NewsContent/index.html?id="+dataList[i].id,target:'_blank'},children:[
                {tag:'div',classList:["shotImage"],children:[
                    {tag:"div",classList:["imageContainer"],children:[
                        {tag:'div',classList:["imgBox"],children:[
                            {tag:'img',setting:{src:dataList[i].image}}
                        ]}
                    ]}
                ]}
            ]},
            {tag:'div',classList:["textContainer"],children:[
                {tag:'h4',classList:["title"],text:dataList[i].title},
                {tag:'div',classList:["boxDate"],text:day(dataList[i].createDate*1000).format("YYYY-MM-DD HH:mm:ss")},
            ]}
          ]
      })
    }
    createComponent(nodeList,node)
  };